import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmdDropdownModule } from '../dropdown/dropdown.module';
import { AmdInputModule } from '../input/input.module';
import { AmdInputContainerModule } from '../input-container/input-container.module';
import { AmdOptionModule } from '../option/option.module';
import { AmdSelectComponent } from './select.component';
export class AmdSelectModule {
}
AmdSelectModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule, AmdOptionModule,
                    AmdInputModule, AmdDropdownModule,
                    AmdInputContainerModule
                ],
                declarations: [AmdSelectComponent],
                exports: [AmdSelectComponent, AmdOptionModule]
            },] },
];
/**
 * @nocollapse
 */
AmdSelectModule.ctorParameters = () => [];
function AmdSelectModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSelectModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSelectModule.ctorParameters;
}
//# sourceMappingURL=select.module.js.map
//# sourceMappingURL=select.module.js.map
